export { default as ThreeDStockDetectedObjectMatches } from './ThreeDStockDetectedObjectMatches';
